<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      loading: false,
      sending: false,
      saving: false,
      adding: false,

      importData: null,
      list: null,

      selectedIds: [],
      selectAll: false,

      fields: [
        { key: "select",             label: "",            sortable: false, tdClass: "text-center", thClass: "text-center" },
        { key: "name",               label: "Nome",        sortable: false },
        { key: "person_number",      label: "CPF/CNPJ",    sortable: false },
        { key: "type",               label: "Tipo",        sortable: false, tdClass: "text-center", thClass: "text-center" },
        { key: "partner_name",       label: "Nome Sócio",  sortable: false },
        { key: "partner_cpf",        label: "CPF Sócio",   sortable: false },
        { key: "email",               label: "Email",       sortable: false },
        { key: "cellphone",           label: "Celular",    sortable: false },
        { key: "status",             label: "Status",      sortable: false, tdClass: "text-center", thClass: "text-center" },
        { key: "validation_message", label: "Observação",  sortable: false },
        { key: "actions",            label: "Ações",       sortable: false, tdClass: "text-center", thClass: "text-center" },
      ],

      currentPage: 1,
      perPage: 25,

      editForm: {
        id:            null,
        name:          "",
        person_number: "",
        partner_name:  "",
        partner_cpf:   "",
        email:        "",
        cellphone:    "",
      },

      addForm: {
        name:          "",
        person_number: "",
        partner_name:  "",
        partner_cpf:   "",
        email:        "",
        cellphone:    "",
      },
    };
  },
  computed: {
    idImport() {
      return this.$route.params.id;
    },
    totalRows() {
      return this.list ? this.list.length : 0;
    },
    paginatedList() {
      if (!this.list) return [];
      const start = (this.currentPage - 1) * this.perPage;
      return this.list.slice(start, start + this.perPage);
    },
    validItems() {
      if (!this.list) return [];
      return this.list.filter((i) => i.status === "valid");
    },
    sentItems() {
      if (!this.list) return [];
      return this.list.filter((i) => i.status === "sent");
    },
    importConsolidada() {
      return this.importData && this.importData.status === "sent";
    },
  },
  methods: {
    getImport() {
      this.loading = true;
      this.list    = null;

      api
        .get("jusbrasil/imports/" + this.idImport)
        .then((response) => {
          if (response.data.status === "success") {
            this.importData = response.data.import;
            this.list       = response.data.list;
            this.selectedIds = [];
            this.selectAll   = false;
            this.currentPage = 1;
          } else {
            this.$router.push("/jusbrasil/importacoes");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedIds = this.validItems.map((i) => i.id);
      } else {
        this.selectedIds = [];
      }
    },

    toggleItem(id) {
      const idx = this.selectedIds.indexOf(id);
      if (idx === -1) {
        this.selectedIds.push(id);
      } else {
        this.selectedIds.splice(idx, 1);
      }
      this.selectAll = this.selectedIds.length === this.validItems.length && this.validItems.length > 0;
    },

    openEdit(item) {
      this.editForm = {
        id:            item.id,
        name:          item.name,
        person_number: item.person_number,
        partner_name:  item.partner_name,
        partner_cpf:   item.partner_cpf,
        email:         item.email || "",
        cellphone:     item.cellphone || "",
      };
      this.$bvModal.show("modal-edit");
    },

    saveEdit() {
      if (!this.editForm.name || !this.editForm.person_number) return;

      this.saving = true;

      api
        .post("jusbrasil/imports/items/edit", {
          id:            this.editForm.id,
          name:          this.editForm.name,
          person_number: this.editForm.person_number,
          partner_name:  this.editForm.partner_name,
          partner_cpf:   this.editForm.partner_cpf,
          email:        this.editForm.email,
          cellphone:    this.editForm.cellphone,
        })
        .then((response) => {
          if (response.data.status === "success") {
            const item = this.list.find((i) => i.id === this.editForm.id);
            if (item) {
              item.name               = this.editForm.name.toUpperCase();
              item.person_number      = response.data.person_number;
              item.partner_name       = this.editForm.partner_name.toUpperCase();
              item.partner_cpf        = response.data.partner_cpf || this.editForm.partner_cpf;
              item.type               = response.data.type;
              item.status             = response.data.item_status;
              item.validation_message = response.data.validation_message;
              item.email              = typeof response.data.email !== "undefined" ? response.data.email : item.email;
              item.cellphone          = typeof response.data.cellphone !== "undefined" ? response.data.cellphone : item.cellphone;
            }
            this.$bvModal.hide("modal-edit");
          } else if (response.data.message) {
            this.$toast.error(response.data.message);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    },

    openAdd() {
      this.addForm = {
        name:          "",
        person_number: "",
        partner_name:  "",
        partner_cpf:   "",
        email:        "",
        cellphone:    "",
      };
      this.$bvModal.show("modal-add");
    },

    saveAdd() {
      if (!this.addForm.name || !this.addForm.person_number) return;

      this.adding = true;

      api
        .post("jusbrasil/imports/items/add", {
          id_import:     this.idImport,
          name:          this.addForm.name,
          person_number: this.addForm.person_number,
          partner_name:  this.addForm.partner_name,
          partner_cpf:   this.addForm.partner_cpf,
          email:        this.addForm.email,
          cellphone:    this.addForm.cellphone,
        })
        .then((response) => {
          if (response.data.status === "success") {
            this.list.push(response.data.item);
            this.$bvModal.hide("modal-add");
          } else if (response.data.message) {
            this.$toast.error(response.data.message);
          }
        })
        .finally(() => {
          this.adding = false;
        });
    },

    sendSelected() {
      if (this.selectedIds.length === 0) return;
      this.doSend(false);
    },

    sendAllValid() {
      this.doSend(true);
    },

    doSend(sendAll) {
      this.sending = true;

      const payload = {
        id_import: this.idImport,
        send_all:  sendAll ? "1" : "0",
      };

      if (!sendAll) {
        payload.ids = this.selectedIds;
      }

      api
        .post("jusbrasil/imports/send", payload)
        .then((response) => {
          if (response.data.status === "success") {
            this.$bvModal.hide("modal-send-confirm");
            this.$bvModal.hide("modal-send-all-confirm");
            this.getImport();
          } else if (response.data.message) {
            this.$toast.error(response.data.message);
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },

    confirmSendSelected() {
      if (this.selectedIds.length === 0) return;
      this.$bvModal.show("modal-send-confirm");
    },

    confirmSendAll() {
      this.$bvModal.show("modal-send-all-confirm");
    },

    typeLabel(type) {
      if (type === "pf") return "PF";
      if (type === "pj") return "PJ";
      return "–";
    },

    typeVariant(type) {
      if (type === "pf") return "info";
      if (type === "pj") return "primary";
      return "secondary";
    },

    statusLabel(status) {
      const map = {
        valid:   "Válido",
        invalid: "Inválido",
        sent:    "Enviado",
      };
      return map[status] || status;
    },

    statusVariant(status) {
      const map = {
        valid:   "success",
        invalid: "danger",
        sent:    "secondary",
      };
      return map[status] || "secondary";
    },
  },
  mounted() {
    this.getImport();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"></path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">
        <router-link tag="a" to="/jusbrasil">Jusbrasil</router-link>
      </li>
      <li class="breadcrumb-item">
        <router-link tag="a" to="/jusbrasil/importacoes">Importações</router-link>
      </li>
      <li class="breadcrumb-item active">Revisar</li>
    </ol>

    <div v-if="loading" class="text-center py-5">
      <b-spinner variant="default"></b-spinner>
    </div>

    <div v-else-if="importData">

      <b-alert v-if="importConsolidada" variant="secondary" show class="mb-3 mb-md-4">
        Importação consolidada. Não é possível alterar ou enviar registros.
      </b-alert>

      <!-- Cabeçalho com info da importação -->
      <div class="page-title-box d-md-flex justify-content-between mb-3">
        <div>
          <h3>{{ importData.filename }}</h3>
          <p class="text-muted mb-0">
            Importado em {{ importData.date_added }}
          </p>
        </div>
        <div class="d-flex align-items-center mt-2 mt-md-0 flex-wrap">
          <b-button v-if="!importConsolidada" variant="outline-secondary" size="sm" class="mr-2 mb-1 mb-md-0" @click="openAdd">
            <i class="bx bx-plus mr-1"></i> Adicionar Linha
          </b-button>
          <b-button
            variant="outline-default"
            size="sm"
            class="mr-2 mb-1 mb-md-0"
            :disabled="importConsolidada || selectedIds.length === 0 || sending"
            @click="confirmSendSelected"
          >
            Enviar Selecionados ({{ selectedIds.length }})
          </b-button>
          <b-button
            variant="default"
            size="sm"
            class="mb-1 mb-md-0"
            :disabled="importConsolidada || validItems.length === 0 || sending"
            @click="confirmSendAll"
          >
            Enviar Todos Válidos ({{ validItems.length }})
          </b-button>
        </div>
      </div>

      <!-- Cards de totais -->
      <div class="row mb-3">
        <div class="col-6 col-md-3 mb-2">
          <div class="card mb-0">
            <div class="card-body py-2 text-center">
              <div class="text-muted small">Total</div>
              <div class="font-weight-bold">{{ importData.total }}</div>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-3 mb-2">
          <div class="card mb-0">
            <div class="card-body py-2 text-center">
              <div class="text-muted small">Válidos</div>
              <div class="font-weight-bold text-success">{{ validItems.length }}</div>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-3 mb-2">
          <div class="card mb-0">
            <div class="card-body py-2 text-center">
              <div class="text-muted small">Inválidos</div>
              <div class="font-weight-bold text-danger">{{ totalRows - validItems.length - sentItems.length }}</div>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-3 mb-2">
          <div class="card mb-0">
            <div class="card-body py-2 text-center">
              <div class="text-muted small">Enviados</div>
              <div class="font-weight-bold text-secondary">{{ sentItems.length }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabela de itens -->
      <div class="card">
        <div class="card-body">

          <div v-if="list && list.length === 0" class="text-center py-5 text-muted">
            Nenhum item encontrado.
          </div>

          <div v-else-if="list">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  v-model="selectAll"
                  @change="toggleSelectAll"
                  :disabled="importConsolidada"
                  class="mr-2"
                >
                  Selecionar todos válidos
                </b-form-checkbox>
                <span class="text-muted small">{{ totalRows }} registro(s)</span>
              </div>
              <b-form-select
                v-model="perPage"
                :options="[10, 25, 50, 100]"
                size="sm"
                style="width: auto;"
              ></b-form-select>
            </div>

            <div class="table-responsive">
              <b-table
                :items="paginatedList"
                :fields="fields"
                responsive
                hover
                show-empty
                empty-text="Nenhum registro encontrado."
              >
                <template #cell(select)="data">
                  <b-form-checkbox
                    v-if="data.item.status === 'valid' && !importConsolidada"
                    :checked="selectedIds.includes(data.item.id)"
                    @change="toggleItem(data.item.id)"
                  ></b-form-checkbox>
                </template>

                <template #cell(type)="data">
                  <b-badge :variant="typeVariant(data.item.type)">
                    {{ typeLabel(data.item.type) }}
                  </b-badge>
                </template>

                <template #cell(status)="data">
                  <b-badge :variant="statusVariant(data.item.status)">
                    {{ statusLabel(data.item.status) }}
                  </b-badge>
                </template>

                <template #cell(actions)="data">
                  <b-button
                    v-if="!importConsolidada && data.item.status !== 'sent'"
                    size="sm"
                    variant="outline-secondary"
                    @click="openEdit(data.item)"
                  >
                    <i class="bx bx-edit"></i>
                  </b-button>
                </template>
              </b-table>
            </div>

            <div class="d-flex justify-content-center mt-3" v-if="totalRows > perPage">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="center"
              ></b-pagination>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Modal Editar Item -->
    <b-modal id="modal-edit" title="Editar Registro" centered hide-footer>
      <div class="form-group">
        <label>Nome / Razão Social <span class="text-danger">*</span></label>
        <b-form-input v-model="editForm.name" size="sm" placeholder="Nome ou razão social"></b-form-input>
      </div>
      <div class="form-group">
        <label>CPF / CNPJ <span class="text-danger">*</span></label>
        <b-form-input v-model="editForm.person_number" size="sm" placeholder="Somente números"></b-form-input>
      </div>
      <div class="form-group">
        <label>Nome do Sócio</label>
        <b-form-input v-model="editForm.partner_name" size="sm" placeholder="Obrigatório para CNPJ"></b-form-input>
      </div>
      <div class="form-group">
        <label>CPF do Sócio</label>
        <b-form-input v-model="editForm.partner_cpf" size="sm" placeholder="Somente números — obrigatório para CNPJ"></b-form-input>
      </div>
      <div class="form-group">
        <label>Email <span class="text-muted small">(opcional)</span></label>
        <b-form-input v-model="editForm.email" size="sm" type="email" inputmode="email" placeholder="Pode ficar em branco"></b-form-input>
      </div>
      <div class="form-group">
        <label>Celular / WhatsApp <span class="text-muted small">(opcional)</span></label>
        <b-form-input v-model="editForm.cellphone" size="sm" type="text" v-mask="'(##) #####-####'" inputmode="numeric" placeholder="(00) 90000-0000"></b-form-input>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <b-button variant="outline-secondary" size="sm" class="mr-2" @click="$bvModal.hide('modal-edit')">
          Cancelar
        </b-button>
        <b-button variant="default" size="sm" :disabled="saving" @click="saveEdit">
          <b-spinner v-if="saving" small class="mr-1"></b-spinner>
          Salvar e Revalidar
        </b-button>
      </div>
    </b-modal>

    <!-- Modal Adicionar Item -->
    <b-modal id="modal-add" title="Adicionar Registro" centered hide-footer>
      <div class="form-group">
        <label>Nome / Razão Social <span class="text-danger">*</span></label>
        <b-form-input v-model="addForm.name" size="sm" placeholder="Nome ou razão social"></b-form-input>
      </div>
      <div class="form-group">
        <label>CPF / CNPJ <span class="text-danger">*</span></label>
        <b-form-input v-model="addForm.person_number" size="sm" placeholder="Somente números"></b-form-input>
      </div>
      <div class="form-group">
        <label>Nome do Sócio</label>
        <b-form-input v-model="addForm.partner_name" size="sm" placeholder="Obrigatório para CNPJ"></b-form-input>
      </div>
      <div class="form-group">
        <label>CPF do Sócio</label>
        <b-form-input v-model="addForm.partner_cpf" size="sm" placeholder="Somente números — obrigatório para CNPJ"></b-form-input>
      </div>
      <div class="form-group">
        <label>Email <span class="text-muted small">(opcional)</span></label>
        <b-form-input v-model="addForm.email" size="sm" type="email" inputmode="email" placeholder="Pode ficar em branco"></b-form-input>
      </div>
      <div class="form-group">
        <label>Celular / WhatsApp <span class="text-muted small">(opcional)</span></label>
        <b-form-input v-model="addForm.cellphone" size="sm" type="text" v-mask="'(##) #####-####'" inputmode="numeric" placeholder="(00) 90000-0000"></b-form-input>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <b-button variant="outline-secondary" size="sm" class="mr-2" @click="$bvModal.hide('modal-add')">
          Cancelar
        </b-button>
        <b-button variant="default" size="sm" :disabled="adding" @click="saveAdd">
          <b-spinner v-if="adding" small class="mr-1"></b-spinner>
          Adicionar
        </b-button>
      </div>
    </b-modal>

    <!-- Modal Confirmar Envio Selecionados -->
    <b-modal id="modal-send-confirm" title="Confirmar Envio" centered hide-footer>
      <p>Serão enviados <strong>{{ selectedIds.length }}</strong> registro(s) selecionado(s).<br>
        Eles serão adicionados como clientes pendentes de pagamento.</p>
      <div class="d-flex justify-content-end mt-3">
        <b-button variant="outline-secondary" size="sm" class="mr-2" @click="$bvModal.hide('modal-send-confirm')">
          Cancelar
        </b-button>
        <b-button variant="default" size="sm" :disabled="sending" @click="sendSelected">
          <b-spinner v-if="sending" small class="mr-1"></b-spinner>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <!-- Modal Confirmar Envio Todos Válidos -->
    <b-modal id="modal-send-all-confirm" title="Confirmar Envio" centered hide-footer>
      <p>Serão enviados <strong>todos os {{ validItems.length }}</strong> registro(s) válido(s).<br>
        Eles serão adicionados como clientes pendentes de pagamento.</p>
      <div class="d-flex justify-content-end mt-3">
        <b-button variant="outline-secondary" size="sm" class="mr-2" @click="$bvModal.hide('modal-send-all-confirm')">
          Cancelar
        </b-button>
        <b-button variant="default" size="sm" :disabled="sending" @click="sendAllValid">
          <b-spinner v-if="sending" small class="mr-1"></b-spinner>
          Confirmar
        </b-button>
      </div>
    </b-modal>

  </Layout>
</template>
